import React from 'react';
import './PaymentCardHeader.css';

type PaymentCardHeaderProps = {
  title: string;
  subTitle: string;
};

export default function PaymentCardHeader({
  title,
  subTitle,
}: PaymentCardHeaderProps) {
  return (
    <>
      <div className="pt-2 payment-card-title ion-text-center">{title}</div>
      <div className="pt-1 pb-2 payment-card-subtitle ion-text-center">
        {subTitle}
      </div>
    </>
  );
}
